import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { EditAndApproveExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const editAndApproveExternalProviderBatchRequest = createApiThunk<void, EditAndApproveExternalProviderBatchRequestBody>(
  "externalProviderBatchRequests/editAndApproveExternalProviderBatchRequest",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.editAndApproveExternalProviderBatchRequest(body);
  },
);

export const resetEditAndApproveExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetEditAndApproveExternalProviderBatchRequest",
);
